import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (!SENTRY_DSN) {
    console.warn("[Sentry] NEXT_PUBLIC_SENTRY_DSN is not set — error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? "production",
    // Keep sample rate at 100% — this is a low-traffic landing page.
    // Reduce if traffic grows significantly.
    sampleRate: 1.0,
    // Disable session replay and performance tracing to minimize bundle size.
    integrations: [],
    // Only send errors, no performance transactions.
    tracesSampleRate: 0,
  });

  initialized = true;
}

export { Sentry };
